import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';
import { articles } from '@/mocks/articles';

export default function TopicSpotlight() {
  const feature = topics[0];
  const others = topics.slice(1);
  const featureArticles = articles.filter((a) => a.topicId === feature.id);

  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col gap-2 mb-6">
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 flex items-center gap-3">
            <span className="w-1.5 h-6 rounded-full bg-accent-500" />
            特色专题
          </h2>
          <p className="text-sm text-foreground-500 pl-4">聚焦影视话题，深度梳理相关资讯与解读</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <Link
            to={`/topic/${feature.id}`}
            className="lg:col-span-2 group relative rounded-lg overflow-hidden border border-background-200 cursor-pointer"
          >
            <div className="relative w-full h-64 md:h-[380px] overflow-hidden bg-background-200">
              <img
                src={feature.cover}
                alt={`专题：${feature.title}`}
                title={`${feature.title} 资讯专题`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/40 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-primary-950 text-xs font-semibold mb-3">
                <i className="ri-article-line" />
                专题聚焦
              </span>
              <h3 className="font-heading font-bold text-xl md:text-2xl text-background-50 mb-2 leading-snug">
                {feature.title}
              </h3>
              <p className="text-sm text-background-100/80 line-clamp-2 max-w-2xl">
                {feature.intro}
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-accent-400 mt-3">
                共 {featureArticles.length} 篇相关资讯
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>

          <div className="flex flex-col gap-4">
            {others.slice(0, 3).map((topic) => (
              <Link
                key={topic.id}
                to={`/topic/${topic.id}`}
                className="group flex gap-4 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="w-24 h-24 md:w-28 md:h-28 shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={topic.cover}
                    alt={`专题：${topic.title}`}
                    title={`${topic.title} 资讯专题`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col justify-center gap-2 min-w-0">
                  <h3 className="font-heading font-semibold text-sm text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                    {topic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2">{topic.intro}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}